import { getInitials } from 'sutra/utils/get-initials'

import type { ShareResourceMember } from 'components/share-resource/types'
import type { UserInfo } from 'types/project'

/**
 * Owners first, then additional recipients, for a read-only `ShareResource`
 * list. Both roles are `staticRole` text — the view has no `manage` prop, so
 * there is no dropdown to drive. The signed-in user's row keeps the old
 * drawer's "(you)" marker.
 */
export function toAlertShareMembers(
  owners: readonly UserInfo[],
  viewers: readonly UserInfo[],
  currentUserEmail?: string,
): ShareResourceMember[] {
  const isCurrentUser = (email: string): boolean =>
    !!currentUserEmail && email.toLowerCase() === currentUserEmail.toLowerCase()

  const toMember = (
    user: UserInfo,
    staticRole: string,
  ): ShareResourceMember => {
    const name = user.full_name || user.email
    return {
      id: user.email,
      name: isCurrentUser(user.email) ? `${name} (you)` : name,
      secondaryLabel: user.full_name ? user.email : undefined,
      initials: getInitials({ fullName: user.full_name, email: user.email }),
      staticRole,
    }
  }

  return [
    ...owners.map((owner) => toMember(owner, 'Owner')),
    ...viewers.map((viewer) => toMember(viewer, 'Viewer')),
  ]
}
